import List from "@/views/App/Portal/PrivateLearningCoaching/Protocol/List.vue";

const routesPortalPrivateLearningCoaching = [
    {
        path: 'protocol-list/:id',
        name: 'privateLearningCoachingProtocolList',
        component: List
    }
];

export default routesPortalPrivateLearningCoaching;